<!--
하우스 > 통관정보 유효성검사 컴포넌트
------------------------------------
-->
<template>
    <div>
        <!-- [TASK-171] label / showIcon / disabled / buttonClass prop 추가 — 기본값 = 기존 상세 탭 동작·룩 그대로 -->
        <button class="uk-button"
                :class="buttonClass"
                type="button"
                v-show="stateIsReady"
                :disabled="disabled"

                @click="submit"
        >
            <i v-if="showIcon" class="material-icons">refresh</i>
            <span>{{ label }}</span>
        </button>

        <div v-show="stateIsLoading">
            <loading-icon></loading-icon>
            <span>처리중...</span>
        </div>

        <div v-show="stateIsDone">
            <i class="material-icons">done</i>
            <span>유효성 검사완료</span>
        </div>
    </div>


</template>

<script>
    import moment from "moment";
    import LoadingIcon from "../common/loading-icon.vue";
    export default {
        components: {LoadingIcon},
        mixins: [
        ],
        props: {
            // csrf-token
            csrfToken: String,

            /**
             * 하우스ID
             */
            houseId: {
                type: Number,
                default: null,
            },

            /**
             * [TASK-171] 버튼 문구 (기본 = 상세 탭 문구)
             */
            label: {
                type: String,
                default: '통관정보 유효성 검사',
            },

            /**
             * [TASK-171] 버튼 앞 아이콘 표시 여부 (기본 true = 상세 탭 현행. 모달 재검사 버튼도 true — 결정 15)
             */
            showIcon: {
                type: Boolean,
                default: true,
            },

            /**
             * [TASK-171] 버튼 비활성 여부 (모달 입력값 변경 상태 등)
             */
            disabled: {
                type: Boolean,
                default: false,
            },

            /**
             * [TASK-171] 버튼 룩 클래스 (기본 = 상세 탭 현행 작은 회색 버튼. 모달 footer 는 'uk-button-gray uk-text-nowrap' — 작은 크기 아님)
             */
            buttonClass: {
                type: String,
                default: 'uk-button-small uk-button-gray',
            },
        },
        data: function () {
            return {
                // (string) 처리상태 (ready: 대기, loading: 처리중, done: 완료)
                state: 'ready'
            };
        },
        mounted: function () {
            //console.log('mounted in component');
        },
        computed: {
            /**
             * 상태가 ready 인지
             * @returns {boolean}
             */
            stateIsReady() {
                return this.state === 'ready';
            },
            /**
             * 상태가 loading 인지
             * @returns {boolean}
             */
            stateIsLoading() {
                return this.state === 'loading';
            },
            /**
             * 상태가 done 인지
             * @returns {boolean}
             */
            stateIsDone() {
                return this.state === 'done';
            },


        },
        methods: {
            /**
             * 검사실행
             */
            submit() {
                // [TASK-171] 비활성 상태에서는 실행하지 않는다
                if (! this.stateIsReady || this.disabled) {
                    return;
                }
                this.state = 'loading';

                // promise 생성
                let load = new Promise((resolve, reject) => {

                    // ajax 옵션
                    let opts = {
                        type: 'patch',
                        url: '/houses/' + this.houseId + '/customs-validation',
                        data: {
                            _token: this.csrfToken,
                        },
                        success: (response, textStatus, jqXHR) => {
                            // promise 성공
                            resolve(response);
                        },
                        error: function(jqXHR, textStatus, errorThrown) {
                            reject();
                        },
                    };

                    // ajax 실행
                    $.app.ajax.module.background(opts);
                });


                // promise 처리
                load.then((response) => {
                    this.state = 'done';

                    // 페이지 새로고침
                    $.app.refresh();

                }).catch((msg) => {
                    // 오류인경우
                    this.state = 'ready';

                });
            },
        },
    }
</script>

<style lang="scss" scoped>

</style>